import { render } from "./Impressum.vue?vue&type=template&id=bcd2b006&scoped=true"
import script from "./Impressum.vue?vue&type=script&lang=js"
export * from "./Impressum.vue?vue&type=script&lang=js"

import "./Impressum.vue?vue&type=style&index=0&id=bcd2b006&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcd2b006"]])

export default __exports__